import { NgTemplateOutlet } from '@angular/common';
import { Component, Injector, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import OfferAddressPipe from '@app/components/offers/offers-table-view/offer-address.pipe';
import ImageService from '@app/services/image.service';
import AppPathConsts from '@shared/AppPathConsts';
import AppComponentBase from '@shared/common/app-component-base';
import { nullable } from '@shared/common/common-types';
import CdnImagePipe from '@shared/common/pipes/cdn-image.pipe';
import MoneyRangePipe from '@shared/common/pipes/money-range.pipe';
import ProjectStatusClassPipe from '@shared/common/pipes/project-status-class.pipe';
import SmallCompanyLogoPipe from '@shared/common/pipes/small-company-logo.pipe';
import SquareMetresRangePipe from '@shared/common/pipes/square-metres-range.pipe';
import {
    AddressResponseModel,
    ImageSmallResponseModel,
    Money,
} from '@shared/service-proxies/service-proxies';
import UtilsModule from '@shared/utils/utils.module';

@Component({
    selector: 'app-project-summary-card',
    imports: [
        NgTemplateOutlet,
        RouterLink,
        UtilsModule,
        CdnImagePipe,
        MoneyRangePipe,
        SquareMetresRangePipe,
        OfferAddressPipe,
        ProjectStatusClassPipe,
        SmallCompanyLogoPipe,
    ],
    templateUrl: './project-summary-card.component.html',
    styleUrl: './project-summary-card.component.less',
})
class ProjectSummaryCardComponent extends AppComponentBase {
    @Input() projectId?: number;

    @Input() name: nullable<string>;

    @Input() projectStatusName: nullable<string>;

    @Input() priceFrom?: Money;

    @Input() priceTo?: Money;

    @Input() areaFrom?: number;

    @Input() areaTo?: number;

    @Input() address?: AddressResponseModel;

    @Input() employeeName: nullable<string>;

    @Input() primaryImage?: ImageSmallResponseModel;

    @Input() tenantId: nullable<number>;

    @Input() disableOnClick: boolean = false;

    protected readonly AppPathConsts = AppPathConsts;

    constructor(
        injector: Injector,
        private imageService: ImageService,
    ) {
        super(injector);
    }

    get imageSource(): string {
        return this.primaryImage?.image?.source ?? '';
    }

    onImageError(event: Event) {
        this.imageService.handleImageLoadError(event);
    }
}

export default ProjectSummaryCardComponent;
